import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap'

function SingleMonthEarningData({ data, id }) {
    return (
        <>
            <Col md="4">
                <Card className="card-user shadow-lg">
                    <CardBody className='pb-0'>
                        <div className='d-flex justify-content-center bg-info   py-2 rounded' ><p className='text-white '> {data?.month}</p></div>
                        <div className='d-flex justify-content-between mt-2 '>
                            <p>Total Orders :</p>
                            <p>{data?.totalOrders}</p>
                        </div>

                        <div className='d-flex justify-content-between mt-2 '>
                            <p>Total Quantity Sold :</p>
                            <p>{data?.totalQuantitySold}</p>
                        </div>
                        <div className='d-flex justify-content-between mt-2 '>
                            <p>Total Sales :</p>
                            <p>{data?.totalSales} AED</p>
                        </div>
                        <div className='d-flex justify-content-center '>
                            {/* <Link className="btn" to={`/admin/SingleUser/MonthlyEarnings/${id}/${data?.id}`}>View All</Link> */}

                        </div>

                    </CardBody>

                </Card>
            </Col>

        </>
    )
}

export default SingleMonthEarningData